<template>
    <div class="tsoft-header">
        <div class="d-flex align-items-center">
            <div>
                <router-link to="/dashboard">
                    <img :src="'/img/logo-tanasoft.svg'">
                </router-link>
            </div>
        </div>
        <div
            class="d-flex align-items-center ml-4"
            style="overflow: hidden;"
        >
            <div class="mr-3">
                <SidebarNotificationsHrLawyer />
            </div>
            <div class="mr-3">
                Ваш ID: {{ currentUser.id }}
            </div>
            <div>
                <div @click="logout">
                    <b-iconstack
                        font-scale="2.5"
                        class="cursor-pointer"
                    >
                        <b-icon
                            stacked
                            icon="circle-fill"
                            variant="light-gray"
                        />
                        <b-icon
                            stacked
                            icon="door-open"
                            scale="0.5"
                            variant="brown"
                        />
                    </b-iconstack>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mixinTasks } from '@/mixins';
    import { mapGetters, mapActions } from 'vuex';
    
    import SidebarNotificationsHrLawyer from '../../notifications/SidebarNotificationsHrLawyer.vue';
    
    export default {
        components: {
            SidebarNotificationsHrLawyer,
        },
        mixins: [mixinTasks],
        data() {
            return {
            };
        },
    
        computed: {
            ...mapGetters('auth', ['currentUser']),
        },
    
        methods: {
            ...mapActions('auth', ['AUTH_LOGOUT']),
        
            logout() {
                this.AUTH_LOGOUT().then(() => {
                    this.$toast.success('Выход выполнен успешно. Хорошего дня! ☀️', {
                        position: 'top-right',
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 1,
                        showCloseButtonOnHover: true,
                        hideProgressBar: true,
                        closeButton: 'button',
                        icon: 'fa fa-exclamation-triangle',
                        rtl: false,
                    });
                    
                    this.$router.push('/login');
                });
            },
        },
        mounted() {
        },
    };
</script>